import { CcfBox, CcfButton, CcfTypography } from '@nice-ccf/ui-controls';
import styles from './ccf-contact-history-row-details.module.scss';
import { Collapse, TableCell } from '@mui/material';
import { Cancel } from '@mui/icons-material';

/* eslint-disable-next-line */
export interface CcfContactHistoryRowDetailsProps {
  row: any;
  open: boolean;
}

/**
 * used to show contact history row details
 * @param props - CcfContactHistoryRowDetailsProps
 * @example ` <CcfContactHistoryRowDetails />`
 */
export function CcfContactHistoryRowDetails(
  props: CcfContactHistoryRowDetailsProps
) {
  const { row, open } = props;
  return (
    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <CcfBox className={styles.interactionDetailsHeader}>
          <CcfBox>
            <CcfTypography className={styles.title}>
              Interaction Details
            </CcfTypography>
          </CcfBox>
          <CcfBox className={styles.btnContainer}>
            <CcfButton className={`${styles.btn} ${styles.CancelButton}`}>
              <CcfTypography
                className={`${styles.btnText} ${styles.txtCancel}`}
              >
                Cancel
              </CcfTypography>
            </CcfButton>
            <CcfButton className={`${styles.btn} ${styles.redialButton}`}>
              <CcfTypography
                className={`${styles.btnText} ${styles.txtRedial}`}
              >
                Redial
              </CcfTypography>
            </CcfButton>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.interactionDetailsBlock}>
          <CcfBox className={styles.detailsRow}>
            <CcfBox className={styles.detailsLabel}>
              <CcfTypography className={styles.txt}>
                Disposition :
              </CcfTypography>
            </CcfBox>
            <CcfBox className={styles.detailsInfo}>
              <CcfTypography className={styles.txt}>
                {row.disposition}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <CcfBox className={styles.detailsRow}>
            <CcfBox className={styles.detailsLabel}>
              <CcfTypography className={styles.txt}>Notes : </CcfTypography>
            </CcfBox>
            <CcfBox className={styles.detailsInfo}>
              <CcfTypography className={styles.txt}>{row.notes}</CcfTypography>
            </CcfBox>
          </CcfBox>
          <CcfBox className={styles.detailsRow}>
            <CcfBox className={styles.detailsLabel}>
              <CcfTypography className={styles.txt}>Tags : </CcfTypography>
            </CcfBox>
            <CcfBox className={`${styles.detailsInfo} ${styles.tagsContainer}`}>
              {row.tags.map((tag: any) => (
                <CcfButton className={styles.tagBtn}>
                  <CcfTypography className={styles.tagTxt}>{tag}</CcfTypography>{' '}
                  <Cancel style={{ fontSize: '16px' }} />
                </CcfButton>
              ))}
            </CcfBox>
          </CcfBox>
        </CcfBox>
      </Collapse>
    </TableCell>
  );
}

export default CcfContactHistoryRowDetails;
